import { render, staticRenderFns } from "./VSelectDx.vue?vue&type=template&id=92db098c"
import script from "./VSelectDx.vue?vue&type=script&lang=js"
export * from "./VSelectDx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports